<template>
  <section>
    <div
      v-if="hasServicer"
      class="avatar-wrapper"
      :style="`background-color: ${rgbaFromHexAndOpacity($vuetify.theme.themes.light.primary, 0.05)}`"
    >
      <v-avatar
        class="darken-2 avatar"
        data-cy="avatar"
        :size="avatarSize"
        :style="`border: 4px solid ${this.$vuetify.theme.themes.light.primary}`"
      >
        <img
          :src="servicerImageUrl"
          alt="Servicer Image"
          @error="imageAltUrl"
        >
      </v-avatar>
    </div>
    <div
      v-if="hasPartner"
      class="avatar-wrapper partner-wrapper"
      :style="`background-color: ${rgbaFromHexAndOpacity($vuetify.theme.themes.light.primary, 0.05)}`"
    >
      <v-avatar
        class="darken-2 avatar"
        :size="avatarSize"
        :style="`border: 4px solid ${this.$vuetify.theme.themes.light.primary}`"
      >
        <img
          :src="partnerImageUrl"
          alt="Partner Image"
          @error="imageAltUrl"
        >
      </v-avatar>
    </div>
  </section>
</template>

<script>
import { rgbaFromHexAndOpacity } from '~/assets/javascript/utilityFunctions.js'
import { NullServicer, NullPartner } from './nullProfile'

export default {
  props: {
    servicer: {
      type: Object,
      required: true,
      default: () => new NullServicer()
    },
    partner: {
      type: Object,
      required: false,
      default: () => new NullPartner()
    }
  },

  data () {
    return {
      defaultAvatarSize: 160
    }
  },

  computed: {
    hasServicer () {
      return this.servicer?.__typename === 'PublicServicerProfile'
    },
    hasPartner () {
      return this.partner?.__typename === 'PublicPartner'
    },
    servicerImageUrl () {
      return `${this.$props.servicer.profile_image_url}`
    },
    partnerImageUrl () {
      return `${this.$props.partner.profile_image_url}`
    },
    avatarSize () {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md ? this.defaultAvatarSize - 60 : this.defaultAvatarSize
    },
    avatarRingSize () {
      return this.avatarSize + 24
    }
  },

  methods: {
    imageAltUrl (event) {
      event.target.src = 'https://simplenexus.com/images/profile_sihlouette.png'
    },
    rgbaFromHexAndOpacity
  }
}
</script>

<style scoped lang="scss">
  @import '~/assets/css/snui';

  section {
    display: flex;
  }
  .avatar-wrapper {
    position: relative;
    padding: 12px;
    border-radius: 50%;
    z-index: 2;
  }
  .partner-wrapper {
    margin-left: -36px;
    z-index: 1;
  }
  .avatar {
    background: white;
    box-shadow: $sn-shadow-depth-1;
  }
  .avatar img {
    width: 100%;
    height: 100%
  }
</style>
